import { render, staticRenderFns } from "./aRmsYearSalesTableRow.vue?vue&type=template&id=22f3ba4f&scoped=true"
import script from "./aRmsYearSalesTableRow.vue?vue&type=script&lang=js"
export * from "./aRmsYearSalesTableRow.vue?vue&type=script&lang=js"
import style0 from "./aRmsYearSalesTableRow.vue?vue&type=style&index=0&id=22f3ba4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f3ba4f",
  null
  
)

export default component.exports